"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomFloatFromInterval = exports.randomIntFromInterval = exports.Scale = exports.Motion = void 0;
var Marquee_1 = __importDefault(require("./Marquee"));
var Motion_1 = __importDefault(require("./Motion"));
exports.Motion = Motion_1.default;
var Scale_1 = __importDefault(require("./Scale"));
exports.Scale = Scale_1.default;
var util_1 = require("./util");
Object.defineProperty(exports, "randomIntFromInterval", { enumerable: true, get: function () { return util_1.randomIntFromInterval; } });
Object.defineProperty(exports, "randomFloatFromInterval", { enumerable: true, get: function () { return util_1.randomFloatFromInterval; } });
exports.default = Marquee_1.default;
//# sourceMappingURL=index.js.map